export default "__VITE_ASSET__DRiNVBzy__"